import { trackStructEvent } from '@snowplow/browser-tracker'
import { logger } from '@core/logger'

const normalizeTrackingValue = (value?: string | number) => {
  switch (typeof value) {
    case 'undefined':
      return undefined
    case 'number':
      return value

    case 'string': {
      const parsedValue = parseFloat(value)

      if (isNaN(parsedValue)) {
        logger.debug('SNOWPLOW_NON_FLOAT_VALUE', { value })

        return undefined
      }

      return parsedValue
    }

    default:
      logger.debug('SNOWPLOW_NON_FLOAT_VALUE', { value })

      return undefined
  }
}

export type SnowplowClientTrackerParams = {
  action: string
  label?: string | object
  value?: string | number
  category?: string
  property?: string
}

export function buildSnowplowClientTracker(defaultPropertyValue = 'default') {
  return function snowplowClientTracker({
    action,
    label,
    value,
    category = 'Nemo',
    property = defaultPropertyValue,
  }: SnowplowClientTrackerParams) {
    const trackingValue = normalizeTrackingValue(value)

    // in some cases we pass some event's metadata as an object in label
    const trackingLabel =
      typeof label === 'string' ? label : JSON.stringify(label)

    // we use this method for tracking events in end-to-end tests
    logger.debug('SNOWPLOW_TRACKING', {
      category,
      action,
      label: trackingLabel,
      version: property,
      value: trackingValue,
    })

    trackStructEvent({
      category,
      action,
      label: trackingLabel,
      property,
      value: trackingValue,
    })
  }
}
